"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelBrightnessCorrectionState = exports.CollectionModelBrightnessCorrectionStateMutator = void 0;
var tslib_1 = require("tslib");
var id_1 = require("../../../id");
var gamma_brightnessCorrection_1 = require("./gamma.brightnessCorrection");
function makeBrightnessCorrectionState(tag, id) {
    switch (tag) {
        case 'gamma':
            return gamma_brightnessCorrection_1.CollectionModelGammaBrightnessCorrection.state(id);
        default:
            throw new Error("Unknown marker type: \"".concat(tag, "\""));
    }
}
var CollectionModelBrightnessCorrectionStateMutator = /** @class */ (function () {
    function CollectionModelBrightnessCorrectionStateMutator(state) {
        this.state = state;
    }
    CollectionModelBrightnessCorrectionStateMutator.prototype.getState = function () {
        var collectionState = this.state.collection.state;
        var captureBrightnessCorrectionKey = CollectionModelBrightnessCorrectionState.captureBrightnessCorrectionId(this.state.captureId);
        var state = collectionState.getFieldValue(captureBrightnessCorrectionKey);
        if (state == null) {
            return [];
        }
        return state.slice();
    };
    CollectionModelBrightnessCorrectionStateMutator.prototype.setState = function (state) {
        var collectionState = this.state.collection.state;
        var captureBrightnessCorrectionKey = CollectionModelBrightnessCorrectionState.captureBrightnessCorrectionId(this.state.captureId);
        collectionState.setFieldValue(captureBrightnessCorrectionKey, state);
    };
    CollectionModelBrightnessCorrectionStateMutator.prototype.create = function (tag, id) {
        if (id === void 0) { id = id_1.IkeId.generate(); }
        var state = makeBrightnessCorrectionState(tag, id);
        return this.createWithState(state);
    };
    CollectionModelBrightnessCorrectionStateMutator.prototype.remove = function (brightnessCorrection) {
        var brightnessCorrectionIds = this.getState();
        var index = brightnessCorrectionIds.indexOf(brightnessCorrection.id);
        if (index === -1) {
            throw new Error("Cannot remove brightness correction. Instance \"".concat(brightnessCorrection.id, "\" is missing from capture \"").concat(this.state.captureId, "\""));
        }
        brightnessCorrectionIds.splice(index, 1);
        this.setState(brightnessCorrectionIds);
        delete this.state.brightnessCorrections[brightnessCorrection.id];
        brightnessCorrection.Mutator.destroyState();
    };
    CollectionModelBrightnessCorrectionStateMutator.prototype.clear = function () {
        var e_1, _a;
        var brightnessCorrections = this.state.values();
        try {
            for (var brightnessCorrections_1 = tslib_1.__values(brightnessCorrections), brightnessCorrections_1_1 = brightnessCorrections_1.next(); !brightnessCorrections_1_1.done; brightnessCorrections_1_1 = brightnessCorrections_1.next()) {
                var brightnessCorrection = brightnessCorrections_1_1.value;
                var brightnessCorrectionIds = this.getState();
                var index = brightnessCorrectionIds.indexOf(brightnessCorrection.id);
                if (index === -1) {
                    continue;
                }
                this.remove(brightnessCorrection);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (brightnessCorrections_1_1 && !brightnessCorrections_1_1.done && (_a = brightnessCorrections_1.return)) _a.call(brightnessCorrections_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    CollectionModelBrightnessCorrectionStateMutator.prototype.createWithState = function (state) {
        var collectionState = this.state.collection.state;
        var captureId = this.state.captureId;
        var stateId = CollectionModelBrightnessCorrectionState.brightnessCorrectionId(captureId, state.id);
        if (collectionState.fields.get(stateId) != null) {
            throw new Error("Brightness Correction \"".concat(stateId, "\" already exists"));
        }
        collectionState.setFieldValue(stateId, state);
        var brightnessCorrectionState = this.getState();
        brightnessCorrectionState.push(state.id);
        this.setState(brightnessCorrectionState);
        return state.id;
    };
    return CollectionModelBrightnessCorrectionStateMutator;
}());
exports.CollectionModelBrightnessCorrectionStateMutator = CollectionModelBrightnessCorrectionStateMutator;
var ID_PREFIX_BRIGHTNESS_CORRECTION = 'b';
var ID_PREFIX_CAPTURE_BRIGHTNESS_CORRECTION = 'bl';
var CollectionModelBrightnessCorrectionState = /** @class */ (function () {
    function CollectionModelBrightnessCorrectionState(collection, captureId) {
        this.Mutator = new CollectionModelBrightnessCorrectionStateMutator(this);
        this.id = id_1.IkeId.generate();
        this.brightnessCorrections = {};
        this.collection = collection;
        this.captureId = captureId;
    }
    CollectionModelBrightnessCorrectionState.brightnessCorrectionId = function (captureId, brightnessCorrectionId) {
        return "".concat(ID_PREFIX_BRIGHTNESS_CORRECTION, ":").concat(captureId, ":").concat(brightnessCorrectionId);
    };
    CollectionModelBrightnessCorrectionState.captureBrightnessCorrectionId = function (captureId) {
        return "".concat(ID_PREFIX_CAPTURE_BRIGHTNESS_CORRECTION, ":").concat(captureId);
    };
    CollectionModelBrightnessCorrectionState.getCaptureBrightnessCorrectionId = function (key) {
        if (key.startsWith("".concat(ID_PREFIX_CAPTURE_BRIGHTNESS_CORRECTION, ":"))) {
            return key.substr(3);
        }
        return null;
    };
    CollectionModelBrightnessCorrectionState.prototype.hasBrightnessCorrection = function (brightnessCorrectionId) {
        return (this.state.indexOf(brightnessCorrectionId) > -1);
    };
    CollectionModelBrightnessCorrectionState.prototype.useInExportCorrection = function (brightnessCorrectionId) {
        if (!(this.hasBrightnessCorrection(brightnessCorrectionId))) {
            return false;
        }
        else {
            var brightness = this.getBrightnessCorrection(brightnessCorrectionId);
            switch (brightness.state.tag) {
                case 'gamma':
                    var exp = this.getBrightnessCorrection(brightnessCorrectionId).exponent;
                    return (exp !== 1);
                default:
                    return false;
            }
        }
    };
    CollectionModelBrightnessCorrectionState.prototype.getBrightnessCorrection = function (brightnessCorrectionId) {
        var brightnessCorrection = this.brightnessCorrections[brightnessCorrectionId];
        if (brightnessCorrection == null) {
            var brightnessCorrectionState = this.collection.state.getFieldValue(CollectionModelBrightnessCorrectionState.brightnessCorrectionId(this.captureId, brightnessCorrectionId)); //FIXME
            if (brightnessCorrectionState == null) {
                //if we can't find a state with the current id, we recreate a new state with the same id, and query it again
                this.Mutator.create('gamma', brightnessCorrectionId);
                brightnessCorrectionState = this.collection.state.getFieldValue(CollectionModelBrightnessCorrectionState.brightnessCorrectionId(this.captureId, brightnessCorrectionId));
            }
            switch (brightnessCorrectionState.tag) {
                case 'gamma':
                    brightnessCorrection = new gamma_brightnessCorrection_1.CollectionModelGammaBrightnessCorrection(this, brightnessCorrectionId, this.captureId);
                    break;
                default:
                    throw new Error("Capture ".concat(this.captureId, ":Unknown brightness correction type: \"").concat(brightnessCorrectionState.tag, "\""));
            }
            this.brightnessCorrections[brightnessCorrectionId] = brightnessCorrection;
        }
        return brightnessCorrection;
    };
    CollectionModelBrightnessCorrectionState.prototype.values = function () {
        var e_2, _a;
        var output = [];
        try {
            for (var _b = tslib_1.__values(this.state), _c = _b.next(); !_c.done; _c = _b.next()) {
                var brightnessCorrectionId = _c.value;
                var brightnessCorrection = this.getBrightnessCorrection(brightnessCorrectionId);
                output.push(brightnessCorrection);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return output;
    };
    CollectionModelBrightnessCorrectionState.prototype.useInExportCorrections = function () {
        var _this = this;
        var state = false;
        if (this.hasBrightnessCorrections()) {
            this.state.forEach(function (el) {
                state = _this.useInExportCorrection(el);
            });
        }
        return state;
    };
    CollectionModelBrightnessCorrectionState.prototype.hasBrightnessCorrections = function () {
        return this.state.length > 0;
    };
    Object.defineProperty(CollectionModelBrightnessCorrectionState.prototype, "capture", {
        get: function () {
            return this.collection.state.getCapture(this.captureId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelBrightnessCorrectionState.prototype, "state", {
        get: function () {
            return this.collection.state.getFieldValue(CollectionModelBrightnessCorrectionState.captureBrightnessCorrectionId(this.captureId)) || [];
        },
        enumerable: false,
        configurable: true
    });
    return CollectionModelBrightnessCorrectionState;
}());
exports.CollectionModelBrightnessCorrectionState = CollectionModelBrightnessCorrectionState;
//# sourceMappingURL=brightnessCorrection.state.js.map